import React, { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { companyService } from '../../services/companyService';
import { authService } from '../../services/authService';
import CompanyNav from '../../components/CompanyNav';
import CompanyBottomNavigation from '../../components/CompanyBottomNavigation';
import Loader from '../../components/Loader';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const UserCreate = () => {
    const user = authService.getCurrentUser();
    const companyId = useMemo(() => user?.company?.id || user?.company_id, [user]);
    const [saving, setSaving] = useState(false);
    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
        role: 'employee',
    });
    const navigate = useNavigate();

    if (!companyId) {
        return <Loader fullScreen={true} size="large" />;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setSaving(true);
            await companyService.addUser(companyId, form);
            //   toast.success('تم إضافة المستخدم بنجاح');
            //   show success message in swal
            Swal.fire({
                title: 'تم إضافة المستخدم بنجاح',
                icon: 'success',
                timer: 1500,
            });
            navigate('/company/users');
        } catch (error) {
            const message = error?.response?.data?.message || 'فشل إضافة المستخدم';
            //   toast.error(message);
            //   show error message in swal
            Swal.fire({
                title: message,
                icon: 'error',
                timer: 2500,
            });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="employee-home-page" dir="rtl">
            <CompanyNav user={user} />

            {/* Header */}
            <div className="px-3 mb-3 mt-3">
                <div className="edit-hero">
                    <div className="edit-hero-inner">
                        <button
                            className="settings-back-btn"
                            onClick={() => navigate(-1)}
                            style={{ background: 'transparent', border: 0 }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#343330" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                        <div className="edit-hero-badge">➕</div>
                        <div className="edit-hero-text">
                            <div className="edit-hero-title">إضافة مستخدم جديد</div>
                            <div className="edit-hero-subtitle">قم بإنشاء حساب مستخدم مرتبط بشركتك</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form */}
            <div className="all-jobs-section px-3 mb-5">
                <div className="edit-card mb-4">
                    <form onSubmit={handleSubmit}>
                        <div className="grid-2">
                            <div className="form-group-modern">
                                <label className="form-label">الاسم</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    className="form-control-modern"
                                    placeholder="اسم المستخدم"
                                    required
                                />
                                <small className="form-hint">اكتب الاسم الكامل كما سيظهر للمستخدمين</small>
                            </div>
                            <div className="form-group-modern">
                                <label className="form-label">البريد الإلكتروني</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    className="form-control-modern"
                                    placeholder="email@example.com"
                                    required
                                />
                                <small className="form-hint">سيرسل إلى هذا البريد إشعارات الحساب</small>
                            </div>
                            <div className="form-group-modern" dir='ltr'>
                                <label className="form-label">رقم الجوال</label>
                                <PhoneInput
                                    international
                                    defaultCountry="EG"
                                    value={form.phone}
                                    onChange={(val) => setForm((prev) => ({ ...prev, phone: val }))}
                                    className="phone-input-custom"
                                />
                                <small className="form-hint">أدخل رقمًا مع رمز الدولة (مثال: +20)</small>
                            </div>
                            <div className="form-group-modern">
                                <label className="form-label">الدور</label>
                                <select
                                    name="role"
                                    value={form.role}
                                    onChange={handleChange}
                                    className="form-control-modern"
                                    required
                                >
                                    <option value="employee">موظف</option>
                                    <option value="admin">مشرف</option>
                                </select>
                                <small className="form-hint">المشرف لديه صلاحيات أوسع لإدارة بيانات الشركة</small>
                            </div>
                            <div className="form-group-modern">
                                <label className="form-label">كلمة المرور</label>
                                <input
                                    type="password"
                                    name="password"
                                    value={form.password}
                                    onChange={handleChange}
                                    className="form-control-modern"
                                    placeholder="********"
                                    required
                                    minLength={6}
                                />
                                <small className="form-hint">الحد الأدنى 6 أحرف</small>
                            </div>
                            <div className="form-group-modern">
                                <label className="form-label">تأكيد كلمة المرور</label>
                                <input
                                    type="password"
                                    name="password_confirmation"
                                    value={form.password_confirmation}
                                    onChange={handleChange}
                                    className="form-control-modern"
                                    placeholder="********"
                                    required
                                    minLength={6}
                                />
                            </div>
                        </div>
                        <div className="actions">
                            <button
                                type="submit"
                                className="btn-primary-modern"
                                disabled={saving}
                            >
                                {saving ? 'جارٍ الحفظ...' : 'إضافة'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* Local styles for modern, creative look */}
            <style>
                {`
          .edit-hero {
            background: linear-gradient(135deg, rgba(96,143,211,0.15) 0%, rgba(74,123,196,0.15) 100%);
            border-radius: 18px;
            padding: 14px 16px;
          }
          .edit-hero-inner {
            display: flex;
            align-items: center;
            gap: 12px;
          }
          .edit-hero-badge {
            width: 44px;
            height: 44px;
            border-radius: 12px;
            display: grid;
            place-items: center;
            background: linear-gradient(135deg, #608fd3 0%, #4a7bc4 100%);
            color: #fff;
            font-size: 22px;
            box-shadow: 0 10px 20px rgba(76, 116, 179, 0.25);
          }
          .edit-hero-title {
            font-weight: 800;
            font-size: 1.1rem;
          }
          .edit-hero-subtitle {
            color: #475569;
            font-size: 0.9rem;
          }
          .edit-card {
            background: #ffffff;
            border-radius: 16px;
            padding: 18px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.05);
            border: 1px solid #eef2f7;
          }
          .grid-2 {
            display: grid;
            grid-template-columns: 1fr;
            gap: 14px;
          }
          @media (min-width: 768px) {
            .grid-2 {
              grid-template-columns: 1fr 1fr;
            }
          }
          .form-group-modern {
            display: flex;
            flex-direction: column;
            gap: 6px;
          }
          .form-control-modern {
            width: 100%;
            border: 1px solid #e5e7eb;
            background: #fafafa;
            padding: 12px 14px;
            border-radius: 12px;
            outline: none;
            transition: box-shadow 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
          }
          .form-control-modern:focus {
            border-color: #4a7bc4;
            background: #fff;
            box-shadow: 0 0 0 4px rgba(74, 123, 196, 0.15);
          }
          .form-hint {
            color: #6b7280;
            font-size: 0.8rem;
          }
          .actions {
            display: flex;
            justify-content: flex-start;
            margin-top: 12px;
          }
          .btn-primary-modern {
            background: linear-gradient(135deg, #608fd3 0%, #4a7bc4 100%);
            color: #fff;
            border: none;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 700;
            cursor: pointer;
            box-shadow: 0 10px 20px rgba(76, 116, 179, 0.25);
          }
          .btn-primary-modern:disabled {
            opacity: 0.75;
            cursor: not-allowed;
            box-shadow: none;
          }
        `}
            </style>

            <CompanyBottomNavigation />
        </div>
    );
};

export default UserCreate;


